import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const RightSide = styled.div`
  align-items: center;
  display: flex;
  min-width: 20%;
`;

export const LeftSide = styled.div`
  align-items: center;
  display: flex;

  div {
    flex-wrap: nowrap;
  }
  & > span {
    margin-right: 5px;
  }
`;

export const LeftSideContent = styled.div`
  margin-left: 5px;
`;
